import { SelectMobile } from '@cian/ui-kit';
import * as React from 'react';
import { TSelect } from '../../../common/types/options';

type ITMonthMobileGroup = {
  months: TSelect[];
  onChangeMonth: (value: string) => void;
  currentMonth: string;
  ratingIsLoading: boolean;
};

export const MonthMobileGroup: React.FC<ITMonthMobileGroup> = ({
  months,
  onChangeMonth,
  currentMonth,
  ratingIsLoading,
}) => {
  return (
    <div>
      <SelectMobile
        width={142}
        options={months}
        onChange={onChangeMonth}
        title="Выберите месяц"
        placeholder="Месяц"
        disabled={ratingIsLoading}
        value={currentMonth}
      />
    </div>
  );
};
